import React from "react";
import { PROCESSED_REPORTS, REPORT } from "./IntegrationVerificationHelper";
import RequestScoreView from "./processed-reports/RequestScoreView";
import GeneralPerformanceView from "./processed-reports/GeneralPerformanceView";
import GeneralRequestView from "./processed-reports/GeneralRequestView";
import GeneralAdView from "./processed-reports/GeneralAdView";
import ServingRestrictionRequestView from "./processed-reports/ServingRestrictionRequestView";
import PredictedViewabilityView from "./processed-reports/PredictedViewabilityView";
import ActiveCtrView from "./processed-reports/ActiveCtrView";
import InventoryRegistryView from "./processed-reports/InventoryRegistryView";
import SignalAugmentationPositionView from "./processed-reports/SignalAugmentationPositionView";
import SignalAugmentationUserBehaviorView from "./processed-reports/SignalAugmentationUserBehaviorView";
import TrafficAllocationView from "./processed-reports/TrafficAllocationView";
import PrebidRequestView from "./processed-reports/PrebidRequestView";
import BuildRequestView from "./processed-reports/BuildRequestView";

class ProcessedDataView extends React.Component {
  render() {
    const { records, columns, report, dataList, builds = [] } = this.props;

    if (
      report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_1 ||
      report === PROCESSED_REPORTS[REPORT.CODE_SNIPPET].REPORT_1
    )
      return <RequestScoreView records={records} columns={columns} />;

    if (report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_2)
      return <GeneralPerformanceView records={records} columns={columns} />;

    if (report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_3)
      return <GeneralRequestView records={records} columns={columns} />;

    if (report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_4)
      return <GeneralAdView records={records} columns={columns} />;

    if (report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_5)
      return (
        <ServingRestrictionRequestView records={records} columns={columns} />
      );

    if (report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_6)
      return <PredictedViewabilityView records={records} columns={columns} />;

    if (report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_7)
      return <ActiveCtrView records={records} columns={columns} />;

    if (report === PROCESSED_REPORTS[REPORT.AB_TESTING].REPORT_8)
      return (
        <PrebidRequestView
          records={records}
          columns={columns}
          dataList={dataList}
        />
      );

    if (report === PROCESSED_REPORTS[REPORT.CODE_SNIPPET].REPORT_2)
      return <InventoryRegistryView records={records} columns={columns} />;

    if (report === PROCESSED_REPORTS[REPORT.CODE_SNIPPET].REPORT_3)
      return (
        <SignalAugmentationPositionView records={records} columns={columns} />
      );

    if (report === PROCESSED_REPORTS[REPORT.CODE_SNIPPET].REPORT_4)
      return (
        <SignalAugmentationUserBehaviorView
          records={records}
          columns={columns}
        />
      );

    if (report === PROCESSED_REPORTS[REPORT.CODE_SNIPPET].REPORT_5)
      return <TrafficAllocationView dataList={dataList} />;

    if (report === PROCESSED_REPORTS[REPORT.CODE_SNIPPET].REPORT_6)
      return (
        <BuildRequestView
          records={records}
          columns={columns}
          dataList={dataList}
          builds={builds}
        />
      );

    return null;
  }
}

export default ProcessedDataView;
